/* eslint-disable no-unused-vars */
/**
 * Import 3rd party packages
 */
import "../scss/wc-global.scss";

/**
 * Import modules / classes
 */
import WCGlobalDescriptionLines from "./modules/WCGlobalDescriptionLines";

/**
 * Instantiate a new object using imported modules/classes
 */
document.addEventListener("DOMContentLoaded", () => {
    const myWCGlobalDescriptionLines = new WCGlobalDescriptionLines();
});
